
import React, { useEffect, useState, useRef } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import { DatePicker, Input, Select, Pagination, Avatar, Modal } from 'antd';
import { Scrollbars } from "react-custom-scrollbars";
import { getProjectList, delProject, getPlatformInfo } from '../../../actions/majorProjects';
import { getAttachmentFiles } from '../../../actions/newsActivityAction';
import AddOrUpdate from './addAndUpdate';
import ProjectInfo from '../projectInfo';
import add from '../images/add.png';
import project from '../images/project.png';
import edit from '../images/edit.png';
import del from '../images/delete.png';
import './list.scss';



const { Search } = Input
const { confirm } = Modal
const { RangePicker } = DatePicker
const MajorProjectList = (props) => {

    const [keyWords, setKeyWords] = useState('');
    const [time, setTime] = useState([]);

    const [params, setParams] = useState({ time: [], keyWords: '' });
    const [id, setId] = useState({});
    const [projectList, setProjectList] = useState({ list: [], pageSize: 15, total: 0 });
    const [current, setCurrent] = useState(1);
    const [selectItem, setSelectItem] = useState({});
    const addOrUpdateModal = useRef();
    const projectListModal = useRef();



    useEffect(() => {
        if (time.length === 0) {
            searchList(1, getParams());
        }
    }, [time])

    const getParams = () => {
        const startDate = time.length === 0 ? '' : moment(time[0]).format('YYYY-MM-DD HH:mm:ss');
        const endDate = time.length === 0 ? '' : moment(time[1]).format('YYYY-MM-DD HH:mm:ss');
        return { queryStr: keyWords, startDate, endDate }
    }

    //编辑或新增项目
    const editPorject = (type, item) => {
        addOrUpdateModal.current.changeAddModalVisible(true);
        if (type === '新增项目') {
            props.changeModalTitle('新增项目');
        } else {
            setSelectItem(item);
            props.changeProjectName(item.name);
            props.changeProjectCreater(item.manager);
            props.changeProjectContent(item.content);
            // if (item.mediaIds && item.mediaIds.length > 0) {
            //     let mediaIds = item.mediaIds.join(',');
            //     getPlatformInfo({ ids: mediaIds }, function (res) {
            //         if (res.status === 200 && res.msg === 'ok') {
            //             props.changePlatform(res.data);
            //         }
            //     })
            // }
            if (item.fileIds && item.fileIds.length > 0) {
                let attachmentIds = item.fileIds.join(',');
                getAttachmentFiles(attachmentIds).then(res => {
                    let newFileList = [];
                    res && res.map(item => {
                        newFileList.push({
                            url: "images/file.png",
                            uid: item.id,
                            resourceId: item.id,
                            path: item.url,
                            status: "done",
                            name: item.name,
                            icon: <img src={"images/file.png"} width={70} height={90} />
                        })
                    });
                    props.changeProjectAttachment(newFileList);

                })
            }
            props.changeModalTitle('编辑项目');
        }
    }


    //查看项目包含的任务等信息
    const projectInfo = (item) => {
        setTimeout(() => {
            projectListModal.current.changeProjectListModalVisible(true)
        },0);
        setId(item.id);
        setSelectItem(item);
        
    }


    //删除项目
    const deleteProject = (id) => {
        confirm({
            className: 'delete_dialog',
            title: '提示',
            content: '确定删除此项目？',
            okText: '确定',
            okType: 'danger',
            cancelText: '取消',
            onOk() {
                delProject({ id }, (res) => {
                    if (res === true) {
                        searchList(1, getParams())
                    }
                })
            }
        })
    }

    //监听输入关键字改变
    const changeKeyWords = (e) => {
        setKeyWords(e.target.value);
    }

    const onOpenChange = (openFlag) => {
        //关闭窗口触发 搜索功能，
        if (!openFlag) {
            searchList(1, getParams());
        }
    }

    const handleChange = (dates) => {
        setTime(dates);
    }

    const searchList = (current, params) => {
        // let size = 16;//这里不能这么搞，会导致翻页有问题，每页条数必须固定
        let size = 15;
        setCurrent(current);
        // if (current === 1) {
        //     size = 15;
        // }
        let param = { startDate: params.startDate ? params.startDate : '', endDate: params.endDate ? params.endDate : '', queryStr: params.queryStr ? params.queryStr : '', start: current, size: size, }
        window.loading.show();
        getProjectList(param, function (res) {
            if (res.code === 0) {
                setProjectList({ list: res.data, total: res.count, pageSize: size });
                console.log({ list: res.data, total: res.count, pageSize: size });
                window.loading.hide();
            }
        })
    }

    const handlePageChange = (page) => {
        setCurrent(page);
        searchList(page, getParams());
    }

    const reset = () => {
        setKeyWords('');
        setTime([]);
        searchList(1, {});
    }

    let height = window.innerHeight - 70;

    return (
        <div className="major-projects-list" style={{ height }}>
            <div className="title">专题项目</div>
            <div className="condition">
                <div className="left">
                </div>
                <div className="right">
                    <div>
                        <Search
                            placeholder="请输入搜索内容"
                            value={keyWords}
                            onChange={changeKeyWords}
                            onSearch={() => searchList(1, getParams())}
                        />
                    </div>
                    <div>
                        <span style={{ marginRight: 10, fontFamily: 'MicrosoftYaHei', color: '#a4adc8', fontSize: '15px' }}>创建日期</span>
                        <RangePicker showTime={{ defaultValue: [moment('00:00:00', 'HH:mm:ss'), moment('23:59:59', 'HH:mm:ss')] }} showClear onChange={handleChange} value={time} onOpenChange={onOpenChange} />
                    </div>
                    <div>
                        <span className="reset" onClick={reset}>重置筛选</span>
                    </div>
                </div>
            </div>
            <div className="wrap">
                <Scrollbars>
                    <div className="content">
                        <div className="add" onClick={() => editPorject('新增项目')} style={current === 1 ? { display: 'flex' } : { display: 'none' }}>
                            <img src={add} alt="" />
                            <span>创建新项目</span>
                        </div>
                        {
                            projectList.list && (projectList.list.length > 0) && projectList.list.map((item, index) => (
                                <div key={item.id} className={current === 1 ? 'firstItem' : 'otherItem'}>
                                    <div className="top" onClick={() => projectInfo(item)}>
                                        <div className="line_1">
                                            <img src={project} alt="" />
                                            <span>{item.name}</span>
                                        </div>
                                        <div className="line_2">
                                            <div>
                                                <span>包含任务</span>
                                                <span>{item.numbers.total}个</span>
                                            </div>
                                            <div>
                                                <span>提交任务</span>
                                                <span>{item.numbers.commitNum}个</span>
                                            </div>
                                            <div>
                                                <span>完成任务</span>
                                                <span>{item.numbers.finishNum}个</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="bottom">
                                        <div className="left">
                                            <span>{item.manager}</span>
                                        </div>
                                        <div className="right">
                                            <img src={edit} alt="" onClick={() => editPorject('编辑项目', item)} />
                                            <img src={del} alt="" onClick={() => deleteProject(item.id)} />
                                        </div>
                                    </div>
                                </div>

                            ))
                        }
                    </div>
                </Scrollbars>
                <div className="footer">
                    <Pagination current={current} total={projectList.total} pageSize={/*current === 1 ? 15 : 16  这里不能这么搞，会导致翻页有问题*/15} onChange={handlePageChange} />
                </div>
            </div>
            {/* 新增/编辑项目modal */}
            <AddOrUpdate refs={addOrUpdateModal} search={searchList} params={getParams()} item={selectItem} />
            {/* 项目详细信息modal */}
            <ProjectInfo  refs={projectListModal} addOrUpdateModal={addOrUpdateModal} item={selectItem} search={searchList} params={getParams()} id={id} />
        </div>
    )
}


const mapStateToProps = (state) => {
    return {

    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        changeModalTitle: (value) => dispatch({ type: 'CHANGE_MODAL_TITLE', payload: value }),
        changeProjectName: (value) => dispatch({ type: 'CHANGE_PROJECT_NAME', payload: value }),
        changeProjectCreater: (value) => dispatch({ type: 'CHANGE_PROJECT_CREATER', payload: value }),
        changeProjectContent: (value) => dispatch({ type: 'CHANGE_PROJECT_CONTENT', payload: value }),
        changeProjectAttachment: (value) => dispatch({ type: 'CHANGE_PROJECT_ATTACHMENT', payload: value }),
        // changePlatform: (value) => dispatch({ type: 'CHANGE_PLATFORM', payload: value }),
    }

}

export default connect(mapStateToProps, mapDispatchToProps)(MajorProjectList);

//查询项目列表的接口
